<template>
  <div class="app-container">
    <div class="filter-container">
      <span class="px-10">用户</span>
      <el-input
        v-model="listQuery.username"
        placeholder="请输入用户名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.last_name"
        placeholder="请输入姓"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.first_name"
        placeholder="请输入名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.user_id"
        placeholder="请输入用户ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.uuid"
        placeholder="请输入UUID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <span class="px-10">流水号</span>
      <el-input
        v-model="listQuery.cash_out_no"
        placeholder="请输入流水号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <span class="px-10">提现状态</span>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="待审核" value="pending" />
        <el-option label="已驳回" value="reject" />
        <el-option label="处理中" value="processing" />
        <el-option label="已完成" value="completed" />
      </el-select>
      <span class="px-10">提现时间</span>
      <el-date-picker
        class="filter-item"
        v-model="listQuery.date"
        type="daterange"
        @change="changedata"
        range-separator="至"
        :default-time="['00:00:00', '23:59:59']"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-button
        type="primary"
        class="filter-item"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="流水号" width="120">
        <template slot-scope="scope">
          {{ scope.row.cash_out_no }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.user.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.user.username || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.first_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.last_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="提现金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.money ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="提现后余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.after_balance ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="提现时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="驳回原因" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.reject_reason ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="审核状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'pending'" type="pending">
            待审核
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'reject'" type="danger">
            已驳回
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'processing'" type="warning">
            处理中
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'completed'" type="success">
            已完成
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="审核时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_at || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 'pending'"
            size="mini"
            type="success"
            @click="pass(scope.row)"
          >
            审核通过
          </el-button>
          <el-button
            v-if="scope.row.status === 'pending'"
            size="mini"
            type="danger"
            @click="showmodal(scope.row)"
          >
            审核驳回
          </el-button>
          <el-button
            v-if="scope.row.status === 'processing'"
            size="mini"
            type="success"
            @click="complete(scope.row)"
          >
            完成
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        username: '',
        status: '',
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    showmodal(row) {
      this.rejectModalVisible = true
      this.rejectForm.id = row.id
    },
    reject(row) {
      this.$refs['rejectForm'].validate((valid) => {
        if (valid) {
          request({
            url: '/api/backend/userCashOut/reject',
            method: 'post',
            data: {
              reject_reason: this.rejectForm.reason,
              ids: [this.rejectForm.id],
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.rejectModalVisible = false
              this.getList()
            }
          })
        }
      })
    },
    pass(row) {
      this.$confirm('是否确认通过？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/userCashOut/pass',
            method: 'post',
            data: {
              ids: [row.id],
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    complete(row) {
      this.$confirm('是否确认完成？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/userCashOut/complete',
            method: 'post',
            data: {
              ids: [row.id],
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/userCashOut/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
